import React from 'react';
const AdminCustomRadio = ({ name, value, checked, onChange, className, id, ...rest }) => {
    return (

        <input
            name={name}
            value={value}
            type="radio"
            checked={checked}
            onChange={onChange}
            id={id || "radio-button"}
            data-test-id={id || name || "radio-button"}
            className={`r-input ${className}`}
            {...rest}
        />

    );
};

export default AdminCustomRadio;
